<template>
    <section>
        <div class="container box mt-5">
            <h1 class="title">
                Desempeños del Cuerpo Académico
            </h1>

            <ValidationObserver ref="observer">
                <div class="columns">
                    <ValidationProvider class="column" name="Unidad" v-slot="{ errors, failedRules }">
                        <b-field label="Unidad" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <multiselect v-model="unit" :options="units" :custom-label="opt => opt.name" :searchable="true" 
                                :close-on-select="true" :allow-empty="true" selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                                deselectLabel="Presione para deseleccionar" placeholder="Elija una Unidad" />
                        </b-field>
                    </ValidationProvider>

                    <ValidationProvider class="column" name="RUN" rules="min:7|max:8|numeric" v-slot="{ errors, failedRules }">
                        <b-field label="RUN" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <b-input v-model="run" placeholder="Ej: 1234567" type="number" />
                        </b-field>
                    </ValidationProvider>

                    <ValidationProvider class="column" name="DV" rules="min:1|max:1" v-slot="{ errors, failedRules }">
                        <b-field label="DV" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <b-input v-model="dv" placeholder="Ej: 1 o K" />
                        </b-field>
                    </ValidationProvider>
                </div>

                <div class="columns">
                    <ValidationProvider class="column" name="Primer Apellido" rules="min:3|max:255" v-slot="{ errors, failedRules }">
                        <b-field label="Primer Apellido" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <b-input v-model="first_surname" placeholder="Ej: Gutierrez" />
                        </b-field>
                    </ValidationProvider>

                    <ValidationProvider class="column" name="Segundo Apellido" rules="min:3|max:255" v-slot="{ errors, failedRules }">
                        <b-field label="Segundo Apellido" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <b-input v-model="second_surname" placeholder="Ej: Gutierrez" />
                        </b-field>
                    </ValidationProvider>

                    <ValidationProvider class="column" name="Nombres" rules="min:3|max:255" v-slot="{ errors, failedRules }">
                        <b-field label="Nombres" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <b-input v-model="names" placeholder="Ej: Felipe Cristián" />
                        </b-field>
                    </ValidationProvider>
                </div>

                <div class="columns">
                    <ValidationProvider class="column" name="Año" v-slot="{ errors, failedRules }">
                        <b-field label="Año" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <multiselect v-model="year" :options="years" :searchable="true" 
                                :close-on-select="true" :allow-empty="true" selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                                deselectLabel="Presione para deseleccionar" placeholder="Elija un Año" />
                        </b-field>
                    </ValidationProvider>

                    <ValidationProvider class="column" name="Semestre" v-slot="{ errors, failedRules }">
                        <b-field label="Semestre" 
                            :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                            :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                            <multiselect v-model="semester" :options="[1,2]" :searchable="true" 
                                :close-on-select="true" :allow-empty="true" selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                                deselectLabel="Presione para deseleccionar" placeholder="Elija un Semestre" />
                        </b-field>
                    </ValidationProvider>
                </div>

                <div class="columns">
                    <div class="column has-text-right">
                        <b-button label="Aplicar Filtros" type="is-info" icon-left="search" @click="check()" />
                    </div>
                </div>
            </ValidationObserver>

            <div class="columns">
                <div class="column">
                    <b-table striped :data="persons" paginated per-page=10 :pagination-simple=false
                        pagination-position="bottom" aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                        aria-current-label="Página actual">
                        <b-table-column field="name" label="Nombre" v-slot="props">
                            {{ props.row.name }}
                        </b-table-column>
                        <b-table-column field="rut" label="RUT" v-slot="props">
                            {{ props.row.rut }}
                        </b-table-column>
                        <b-table-column field="name" label="Estado del Desempeño" v-slot="props">
                            {{ props.row.performance_state }}
                        </b-table-column>
                        <b-table-column field="id" width="100" label="Acciones" v-slot="props" size="is-small">
                            <b-button pack="fas" icon-right="eye" type="is-info" tag="a"
                                :href="/performances/ + props.row.id" target="_blank" />
                        </b-table-column>
                        <template slot="empty" slot-scope="props">
                            <div class="columns is-centered">
                                <div class="column is-6 is-centered has-text-centered">
                                    <b-message type="is-warning">
                                        No hay registros de Desempeños del Cuerpo Académico.
                                    </b-message>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
export default{
    name: 'PerformancesAcademics',

    props: [
        'units'
    ],

    data() {
        return{
            //Datos para el filtro
            unit: null,
            run: null,
            dv: null,
            first_surname: null,
            second_surname: null,
            names: null,
            year: null,
            semester: null,

            //Datos a traer
            persons: [],

            //Auxiliares
            isLoading: false,
            years: Array.from({length:(new Date().getFullYear()-2000+1)},(v,k)=>k+2000).reverse(),
        }
    },

    methods: {
        async check() {
            const valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Algunos campos presentan errores.', 
                    type: 'is-danger',
                    hasIcon: true, 
                    icon: 'times-circle', 
                    iconPack: 'fa', 
                    ariaRole: 'alertdialog', 
                    ariaModal: true
                })
                return
            }
        }
    }
}
</script>